export const TARCZYNSKI_CLIENT_COMMERCIAL_NETWORK_DIFFERENT_ADDRESSES: Record<string, string> = {
   'Żniwna 3, 62-025 Kostrzyn Wielkopolski': 'Żniwna 3, 62-025 Kostrzyn',
   'Świętego Jerzego 3, 05-808 Brwinów': 'Św. Jerzego 3, 05-808 Parzniew',
   'Podchruście nr 9 ., 32-085 Modlnica': 'Podchruście 9, 32-085 Modlnica',
   'Podchruście nr 9, 32-085 Modlnica': 'Podchruście 9, 32-085 Modlnica',
   'Południowy zachód. Jerzego 3, 05-808 Parzniew': 'Św. Jerzego 3, 05-808 Parzniew',
};
